module.exports = __webpack_public_path__ + "static/the-war-on-normal-people-c794df3cb255900000d33a0bc80fd898.jpg";